import React from "react";
import SidebarDemo from "./SidebarDemo";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import { Outlet } from "react-router-dom";

const SIDEBAR_WIDTH = 250;
const NAVBAR_HEIGHT = 64;
const FOOTER_HEIGHT = 70;

const MainLayout: React.FC = () => {
const isOpen = useSelector((state: RootState) => state.sidebar.isOpen);

  return (
    <>
      <Navbar />
      <Box sx={{ display: "flex", minHeight: "100vh", position: "relative" }}>
        {/* Sidebar */}
        <Box
          sx={{
            width: isOpen ? SIDEBAR_WIDTH : 0,
            flexShrink: 0,
            transition: "width 0.3s",
            overflow: "hidden",
            position: "fixed",
            top: "64px",
            bottom: "70px",
            zIndex: 1099,
            backgroundColor: "#e8f5e9",
            boxShadow: isOpen ? "2px 0 5px rgba(0,0,0,0.15)" : "none",
            borderRight: isOpen ? "1px solid #ddd" : "none",
            height: `calc(100vh - ${NAVBAR_HEIGHT + FOOTER_HEIGHT}px)`,
          }}
        >
          <SidebarDemo />
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            ml: isOpen ? `${SIDEBAR_WIDTH}px` : "0",
            transition: "margin-left 0.3s",
            overflowX: "auto",
            minHeight: "calc(100vh - 134px)", // Ensure content doesn't overlap footer
            paddingBottom: "70px", //  space for footer
            background: "#fff",       
            zIndex: 0,                  
            position: "relative", 
          }}
        >
          <Outlet />
        </Box>
        <Footer />
      </Box>
      <Box sx={{ zIndex: 1000, position: "relative", width: "100%" }}></Box>
    </>
  );
};

export default MainLayout;
